import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

export const bewares = Object.freeze([
  {
    id: 'RDF01',
    value: 'Per Emigrazione',
  },
  {
    id: 'RDF02',
    value: 'Per Immigrazione',
  },
  {
    id: 'RDF03',
    value: 'Per Espulsione',
  },
]);

interface TypologyBewareListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const TypologyBewareListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: TypologyBewareListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="beware-label">
        Tipologia di diffida
      </InputLabel>
      <PmiSelect
        labelId="beware-label"
        id="beware"
        name="beware"
        value={value}
        label="Tipologia di diffida"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {bewares.map((beware: ItemVM) => (
          <MenuItem key={beware.id} value={beware.id}>
            {beware.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypologyBewareListComponent.displayName = 'Typology beware list component';

const TypologyBewareList = memo(TypologyBewareListComponent);

export default TypologyBewareList as typeof TypologyBewareListComponent;
